module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-11.254ad13c.svg";